import React from 'react'
import { useSelector } from 'react-redux'

import { RadioGroup } from '@masfront/common-b2c'
import { Field, Form } from 'formik'

import { Box, Button, Collapse, FormControlLabel, Radio, Typography } from '@material-ui/core'

import PaymentOwner from './PaymentOwner'
import useBillingForm from './UseBillingForm'

import AddressPicker from '~/address/components/AddressPicker'
import { AddressesOptions, AddressType } from '~/address/models/address.model'
import { selectAllSimAddresses } from '~/address/store/address.selectors'
import IbanInput from '~/payments/iban/components/IbanInput'
import useIban from '~/payments/iban/hooks/useIban'
import { LineTypes } from '~/tariff/model/tariff.model'

// @TODO :monkey_face: remove negative margin L:65

export default function BillingForm() {
  const { validateIban, showAutocompleteIban, calculateIban } = useIban()

  const { showPaymentOwner, showOtherAddress } = useBillingForm()

  const addresses = useSelector(selectAllSimAddresses)

  return (
    <Form noValidate>
      <PaymentOwner showPaymentOwner={showPaymentOwner} />
      <Box display="flex">
        <Box px="24px">
          <Field name="iban" component={IbanInput} validate={validateIban} />
        </Box>
        <Box mt={3}>
          <Collapse in={showAutocompleteIban}>
            <Button data-hook="calculate-iban" onClick={calculateIban}>
              Calcular IBAN
            </Button>
          </Collapse>
        </Box>
      </Box>
      <Box px="24px" mt="24px">
        <Box mb="12px">
          <Typography variant="subtitle1">DIRECCIÓN DE FACTURACIÓN</Typography>
        </Box>
        <Field component={RadioGroup} name="address" data-hook="paymentOwner">
          <>
            {addresses.map((address, i) => (
              <FormControlLabel
                key={address}
                value={address}
                control={<Radio color="primary" />}
                label={
                  <Typography variant="body1">
                    {`Línea ${i + 1}: `}
                    <b>{address}</b>
                  </Typography>
                }
              />
            ))}
            <FormControlLabel
              key={AddressesOptions.OTHER}
              value={AddressesOptions.OTHER}
              control={<Radio color="primary" />}
              label={<Typography variant="subtitle1">Otra dirección</Typography>}
            />
          </>
        </Field>
        <Collapse in={showOtherAddress}>
          <Box mt={4} mx={-6}>
            {showOtherAddress && (
              <AddressPicker id={LineTypes.ALL} addressType={AddressType.BILLING} />
            )}
          </Box>
        </Collapse>
      </Box>
    </Form>
  )
}
